import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import PostForm from "./containers/PostForm";
import {Provider} from 'react-redux';
import {createStore} from 'redux';
import combined from './reducers/combined';
import Presenter from './presenters/Editor'

class Editor extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article: {},
            loaded: false
        };
    }

    componentDidMount() {
        const {location: {pathname}, reference} = this.props;
        new Presenter(this.handleData.bind(this)).articleRequest(reference, pathname);
    }

    handleData(article) {
        this.setState({article, loaded: true});
    }

    render() {
        if (this.state.loaded === false) {
            return "";
        }
        const store = createStore(combined, this.state.article);
        return (
            <Provider store={store}>
                <div className="row">
                    <PostForm reference={this.props.reference}/>
                </div>
            </Provider>
        );
    }
}

export default withRouter(Editor);


// WEBPACK FOOTER //
// ./src/admin/components/editor/Editor.js